(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name neo.home.championships
   * @description
   *
   */
  angular
    .module('neo.home.championships', [
      'ui.router',
      'neo.home.championships.newChampionship',
      'neo.home.championships.championship'
    ]);
}());
